const LetterX = (props) => {
  return (
    <svg
      onClick={() => {
        props.deleteFunction();
      }}
      style={props.styles}
      xmlns="http://www.w3.org/2000/svg"
      className={props.className}
      width="20"
      height="20"
      viewBox="0 0 24 24"
      strokeWidth="1.5"
      stroke="#ff2825"
      fill="none"
      strokeLinecap="round"
      strokeLinejoin="round"
    >
      <path stroke="none" d="M0 0h24v24H0z" fill="none" />
      <line x1="18" y1="6" x2="6" y2="18" />
      <line x1="6" y1="6" x2="18" y2="18" />
    </svg>
  );
};

export default LetterX;
